import * as HLF from "html-living-framework";
import * as springroll from "springroll";
import * as Constants from "./Data/Constants";
import { CaptionManager } from "./GameObjects/CaptionManager";
import { LunaCaptionRenderer } from "./GameObjects/LunaCaptionRenderer";
import { VoiceOverManager } from "./GameObjects/VoiceOverManager";
import { BalloonSelection } from "./States/BalloonSelection";
import { Circus } from "./States/Circus";
import { Game } from "./States/Game";
import { Interstitial } from "./States/Interstitial";
import { Results } from "./States/Results";
import { SplashScreen } from "./States/SplashScreen";

import * as CaptionData from "../json/close-caption.json";

export class Application extends HLF.Application {
    private static _instance: Application;
    private _springroll!: springroll.Application;
    private _voiceOver!: VoiceOverManager;
    private _captions!: CaptionManager;

    private constructor() {
        super();
    }

    static get instance() {
        if (Application._instance === undefined) {
            Application._instance = new Application();
        }
        return Application._instance;
    }

    public get voiceOver(): VoiceOverManager {
        return this._voiceOver;
    }

    public init(): void {
        super.init();

        this.initSpringroll();

        this._resizer.sizeMax = new PIXI.Point(1663, 768);

        this._voiceOver = new VoiceOverManager();

        this._captions = new CaptionManager(CaptionData.default);
        this.stage.addChild(this._captions);

        // If we detect we are in the pbs kids games app, disable focus based muting
        // if (/packageName=org\.pbskids\.gamesapp/.test(window.location.search)) {
            // this._audio.setFocusMutingActive(false);
        // }

        this.onResize();
    }

    public update(): void {
        super.update();
        const deltaTime: number = PIXI.ticker.shared.elapsedMS / 1000;
        this._captions.update(deltaTime);
    }

    public destroy(pRemoveView?: boolean, pStageOptions?: boolean | PIXI.StageOptions): void {
        this._voiceOver.destroy();
        super.destroy(pRemoveView, pStageOptions);
    }

    protected registerLoadingScreens(): void {
        this._loader.registerLoadScreen(
            Constants.LOAD_SPLASH,
            new SplashScreen(),
            SplashScreen.getRequiredAssets,
        );
        this._loader.registerLoadScreen(
            Constants.LOAD_INTERSTITIAL,
            new Interstitial(),
            Interstitial.getRequiredAssets,
        );
    }

    protected registerStates(): void {
        this._state.registerState(
            Constants.STATE_GAME,
            () => new Game(),
            Game.getRequiredAssets,
        );
        this._state.registerState(
            Constants.STATE_SELECTION,
            () => new BalloonSelection(),
            BalloonSelection.getRequiredAssets,
        );
        this._state.registerState(
            Constants.STATE_RESULTS,
            () => new Results(),
            Results.getRequiredAssets,
        );
        this._state.registerState(
            Constants.STATE_CIRCUS,
            () => new Circus(),
            Circus.getRequiredAssets,
        );
    }

    protected onLoadRequiredAssetsComplete(): void {
        super.onLoadRequiredAssetsComplete();

        this._audio.setCategoryVolume(HLF.AudioCategory.SFX.toString(), 0.3);
        this._audio.setCategoryVolume(HLF.AudioCategory.BGM.toString(), 0.3);

        this._captions.setRenderer(new LunaCaptionRenderer(Constants.FONT_GEL_PEN_MED_35, 70));
        this._captions.onResize(this._size);

        if (Constants.DEBUG_DEFAULT_STATE === undefined) {
            this._state.transitionTo(Constants.STATE_GAME, Constants.LOAD_SPLASH);
        }
        else {
            this._state.transitionTo(Constants.DEBUG_DEFAULT_STATE, Constants.LOAD_SPLASH);
        }
    }

    private initSpringroll(): void {
        this._springroll = new springroll.Application({
            features: {
                captions: true,
                sound: true,
                vo: false,
                music: false,
                sfx: false,
            },
        });

        this._springroll.state.ready.subscribe(() => {
            this.onSpringrollInitialized();
        });

        this._springroll.state.pause.subscribe((isPaused: boolean) => {
            this.onPause(isPaused);
        });

        this._springroll.state.playOptions.subscribe((playOptions: object) => {
            console.log("New playOptions value set to", playOptions);
        });

        this._springroll.state.captionsMuted.subscribe((result: boolean) => {
            this.onCaptionsMuted(result);
        });

        this._springroll.state.soundVolume.subscribe((result: number) => {
            this.onSoundVolume(result);
        });
    }

    private onSpringrollInitialized(): void {
        // override
    }

    // Springroll message listeners
    private onCaptionsMuted(pMuted: boolean): void {
        this._captions.active = !pMuted;
    }

    private onSoundVolume(pResults: number): void {
        this._audio.masterVolume = pResults;
    }

    private onPause(pIsPaused: boolean): void {
        console.log("paused: " + pIsPaused);
    }
}
